module.exports = __webpack_public_path__ + "static/media/wrangler-swb.1c46ca7f.webp";